"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UITextToolbarButton = _interopRequireDefault(require("UIComponents/editor/UITextToolbarButton"));

var _UITextToolbarIcon = _interopRequireDefault(require("UIComponents/editor/UITextToolbarIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _default = (0, _createReactClass.default)({
  displayName: "SmallToggleButton",
  mixins: [_reactAddonsPureRenderMixin.default],
  render: function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        icon = _this$props.icon,
        onClick = _this$props.onClick,
        tooltip = _this$props.tooltip,
        _this$props$tooltipPl = _this$props.tooltipPlacement,
        tooltipPlacement = _this$props$tooltipPl === void 0 ? 'top' : _this$props$tooltipPl,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["active", "children", "className", "disabled", "icon", "onClick", "tooltip", "tooltipPlacement"]);
    var finalClassName = (0, _classnames.default)(className, 'draft-toolbar-button');
    var shouldForceTooltipClosed = disabled || active;
    return _react.default.createElement(_UITooltip.default, {
      open: shouldForceTooltipClosed ? false : undefined,
      title: tooltip,
      placement: tooltipPlacement
    }, _react.default.createElement(_UITextToolbarButton.default, Object.assign({
      className: finalClassName,
      disabled: disabled,
      onSelectedChange: onClick,
      selected: active
    }, rest), children, _react.default.createElement(_UITextToolbarIcon.default, {
      disabled: disabled,
      name: icon
    })));
  }
});

exports.default = _default;
module.exports = exports.default;